import React, { useContext, useState, useEffect, createContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useLocation, useParams } from "react-router-dom";
import { APIServices } from "./../../helpers/APIServices";
import { UserContext } from "../../Layout";
import dayjs from "dayjs";
import CustomDateHistory from "./CustomDateHistoryAll";
import SimpleBackdrop from "../../Components/Backdrop";
import CustomDateHistoryAll from "./CustomDateHistoryAll";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PartContext = createContext();

export default function HistoryAll() {
  const [value, setValue] = React.useState(0);
  const [data, setData] = React.useState();
  //   const { id } = useParams();
  const [success, setSuccess] = useState(true);
  const user = useContext(UserContext);
  //   const selectPartID = id;

  const [loading, setLoading] = useState(true);

  //   const getData = async (partID) => {
  //     const now = dayjs().toISOString();
  //     const yesterday = dayjs().subtract(1, "day").toISOString();

  //     let test = await APIServices.getPaper(yesterday, now, partID, user);
  //     setData(test.data);
  //   };

  //   const getPart = async () => {
  //     getData(selectPartID);
  //     setLoading(false);
  //   };

  //   useEffect(() => {
  //     if (success) {
  //       setSuccess(false);
  //       getPart();
  //     }
  //   }, [success]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await APIServices.getAllPaperCheckNull();
        console.log(response);
        setData(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <SimpleBackdrop open={loading} setOpen={setLoading} />
      <Box sx={{ width: "100%" }}>
        {data && (
          <CustomDateHistoryAll partData={data} setSuccess={setSuccess} />
        )}
      </Box>
    </div>
  );
}
